import { render, staticRenderFns } from "./HrPermissionsSelector.vue?vue&type=template&id=0ba51b8a&scoped=true"
import script from "./HrPermissionsSelector.vue?vue&type=script&lang=js"
export * from "./HrPermissionsSelector.vue?vue&type=script&lang=js"
import style0 from "./HrPermissionsSelector.vue?vue&type=style&index=0&id=0ba51b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba51b8a",
  null
  
)

export default component.exports